import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadoTomaFisicaENUM, ROUTER_PATHS, sizeTab } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TableTomaFisica from "../../shared/table_toma_fisica/TableTomaFisica";

export default function TomaFisicaPage() {


  const [valueTab, setValueTab] = useState(0);


  return (
    <SingleTableBoxScene
      title="Historial Toma Fisica"
      visibleReport={false}
      urlRedirect={ROUTER_PATHS.inventario.tomaFisicaCrearNav}
      enableRedirect={true}
    >

      <Grid container >

        <Grid item xs={12}>
          <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
            <Tabs
              value={valueTab}
              onChange={(_event: React.SyntheticEvent, newValue: number) => {
                setValueTab(newValue);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="scrollable force tabs preventa"
            >
              <Tab label={'Finalizadas'} {...a11yProps(0)} />
              <Tab label={'Borrador'} {...a11yProps(1)} />
              <Tab label={'Cancelado'} {...a11yProps(2)} />
            </Tabs>
          </Box>
        </Grid>


        <Grid item xs={12}>

          <CustomTabPanel value={valueTab} index={0}>
            <TableTomaFisica
              enable_action={false}
            />
          </CustomTabPanel>

          <CustomTabPanel value={valueTab} index={1}>
            <TableTomaFisica
              estado_solicitud={EstadoTomaFisicaENUM.BORRADOR}
            />
          </CustomTabPanel>

          <CustomTabPanel value={valueTab} index={2}>
            <TableTomaFisica
              enable_action={false}
              estado_solicitud={EstadoTomaFisicaENUM.CANCELADO}
            />
          </CustomTabPanel>

        </Grid>

      </Grid>


    </SingleTableBoxScene>
  )

}